import React from 'react';
import {connect} from 'react-redux';
import DateInput from '../DateInput';
import * as actions from "store/actions/colors"
import validation from '../../validation';
import * as yup from 'yup';

class ImageFinalDateField extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            name: "image_final_date",
            invalid: false
        }
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount(){
   
    }

    handleChange(name, value){
        yup.reach(validation, this.state.name).validate(value, {abortEarly: false}).then( (resp) => {
            this.props.actions.setError(this.state.name, "")
            this.props.actions.change(this.state.name, value)
        }).catch( (err) => {
            for(let error of err.inner){
                this.props.actions.setError(this.state.name, error.message)
            }
        })
    }

    render(){
        return(
            <React.Fragment>
                <DateInput
                     name={this.state.name}
                     placeholder="Insira data de Validade Final"
                     label="Data de Validade Final"
                     onChange={this.handleChange}
                     valid={false}
                     error={this.props.error}
                     selectedDate={this.props.image_final_date}></DateInput>
            </React.Fragment>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        image_final_date: state.colors.color.image_final_date,
        error: state.colors.errors.image_final_date
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions:{
            setError: (name, value) => {
                return dispatch({
                    type: actions.SET_ERROR,
                    payload: {
                        name: name,
                        value: value
                    }
                })
            },
            change: (name, value) => {
                return dispatch({
                    type: actions.CHANGE_ATTR,
                    payload: {
                        name: name,
                        value: value
                    }
                })
            }
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageFinalDateField);